import React, { useState, useContext, useEffect } from "react";
import AdminTopBar from "../Common/AdminTopBar";
import InterfaceMenu from "../Interfaces/InterfaceMenu";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { api_handler } from "../../services/api";
import { faLock, faSave, faDatabase } from "@fortawesome/free-solid-svg-icons";

import { GlobalStateContext,GlobalDispatchContext } from "../../state/GlobalContextProvider";

const Integrate = ({ interface_id }) => {
  const themeState = useContext(GlobalStateContext);
  const dispatch = useContext(GlobalDispatchContext);
  const [isSandboxAuthSimulator, setIsSandboxAuthSimulator] = useState(false);
  const [sandboxAuthURL, setSandboxAuthURL] = useState("");
  const [isSandboxResourceSimulator, setIsSandboxResourceSimulator] = useState(
    false
  );
  const [sandboxResourceURL, setSandboxResourceURL] = useState("");
  const [productionAuthURL, setProductionAuthURL] = useState("");
  const [productionResourceURL, setProductionResourceURL] = useState("");

  useEffect(() => {
    const getInterface = async () => {
      var data = {
        interface_id: interface_id,
      };
      const api_rsp = await api_handler("int-integration:view", data, "POST");

    if (api_rsp.data[0].environment === "sandbox") {
      // sandbox
      setIsSandboxAuthSimulator(
        api_rsp.data[0].auth_function === "stub" ? true : false
      );


      setSandboxAuthURL(
        api_rsp.data[0].auth_function === "stub"
          ? ""
          : api_rsp.data[0].auth_location
      );
      setIsSandboxResourceSimulator(
        api_rsp.data[0].resource_function === "stub" ? true : false
      );
      setSandboxResourceURL(
        api_rsp.data[0].resource_function === "stub"
          ? ""
          : api_rsp.data[0].resource_location
      );
      // production

      setProductionAuthURL(api_rsp.data[1].auth_location);
      setProductionResourceURL(api_rsp.data[1].resource_location);
    } else {
      // sandbox
      setIsSandboxAuthSimulator(
        api_rsp.data[1].auth_function === "stub" ? true : false
      );
      setSandboxAuthURL(
        api_rsp.data[1].auth_function === "stub"
          ? ""
          : api_rsp.data[1].auth_location
      );
      setIsSandboxResourceSimulator(
        api_rsp.data[1].resource_function === "stub" ? true : false
      );
      setSandboxResourceURL(
        api_rsp.data[1].resource_function === "stub"
          ? ""
          : api_rsp.data[1].resource_location
      );
      // production
      setProductionAuthURL(api_rsp.data[0].auth_location);
      setProductionResourceURL(api_rsp.data[0].resource_location);
    }

  };
  getInterface();
}, [interface_id]);


  const handleSandboxAuthURL = (event) => {
    setSandboxAuthURL(event.target.value);
  };

  const handleProductionAuthURL = (event) => {
    setProductionAuthURL(event.target.value);
  };

  const handleSandboxResourceURL = (event) => {
    setSandboxResourceURL(event.target.value);
  };

  const handleProductionResourceURL = (event) => {
    setProductionResourceURL(event.target.value);
  };

  const saveSandboxAuthConf = async () => {
 

    var data = {
      interface_id: interface_id,
      environment: "sandbox",
      auth_function: isSandboxAuthSimulator ? "stub" : "web",
      auth_location: sandboxAuthURL,
      resource_function: isSandboxResourceSimulator ? "stub" : "tc-spec",
      resource_location: sandboxResourceURL,
    };
    const api_rsp = await api_handler("int-integration:update", data, "POST");
    if(api_rsp.code===200) { dispatch({ type: "TRIGGER_TOAST" }) }
    if (api_rsp.data[0].environment === "sandbox") {
      // sandbox
      setIsSandboxAuthSimulator(
        api_rsp.data[0].auth_function === "stub" ? true : false
      );
      setSandboxAuthURL(
        api_rsp.data[0].auth_function === "stub"
          ? ""
          : api_rsp.data[0].auth_location
      );
      setIsSandboxResourceSimulator(
        api_rsp.data[0].resource_function === "stub" ? true : false
      );
      setSandboxResourceURL(
        api_rsp.data[0].resource_function === "stub"
          ? ""
          : api_rsp.data[0].resource_location
      );
      // production

      setProductionAuthURL(api_rsp.data[1].auth_location);
      setProductionResourceURL(api_rsp.data[1].resource_location);
    } else {
      // sandbox
      setIsSandboxAuthSimulator(
        api_rsp.data[1].auth_function === "stub" ? true : false
      );
      setSandboxAuthURL(
        api_rsp.data[1].auth_function === "stub"
          ? ""
          : api_rsp.data[1].auth_location
      );
      setIsSandboxResourceSimulator(
        api_rsp.data[1].resource_function === "stub" ? true : false
      );
      setSandboxResourceURL(
        api_rsp.data[1].resource_function === "stub"
          ? ""
          : api_rsp.data[1].resource_location
      );
      // production
      setProductionAuthURL(api_rsp.data[0].auth_location);
      setProductionResourceURL(api_rsp.data[0].resource_location);
    }
  };

  const saveProductionAuthConf = async () => {
    var data = {
      interface_id: interface_id,
      environment: "production",
      auth_function: "web",
      auth_location: productionAuthURL,
      resource_function: "tc-spec",
      resource_location: productionResourceURL,
    };

    const api_rsp = await api_handler("int-integration:update", data, "POST");
    if(api_rsp.code===200) { dispatch({ type: "TRIGGER_TOAST" }) }
    if (api_rsp.data[0].environment === "sandbox") {
      // sandbox
      setIsSandboxAuthSimulator(
        api_rsp.data[0].auth_function === "stub" ? true : false
      );
      setSandboxAuthURL(
        api_rsp.data[0].auth_function === "stub"
          ? ""
          : api_rsp.data[0].auth_location
      );
      setIsSandboxResourceSimulator(
        api_rsp.data[0].resource_function === "stub" ? true : false
      );
      setSandboxResourceURL(
        api_rsp.data[0].resource_function === "stub"
          ? ""
          : api_rsp.data[0].resource_location
      );
      // production

      setProductionAuthURL(api_rsp.data[1].auth_location);
      setProductionResourceURL(api_rsp.data[1].resource_location);
    } else {
      // sandbox
      setIsSandboxAuthSimulator(
        api_rsp.data[1].auth_function === "stub" ? true : false
      );
      setSandboxAuthURL(
        api_rsp.data[1].auth_function === "stub"
          ? ""
          : api_rsp.data[1].auth_location
      );
      setIsSandboxResourceSimulator(
        api_rsp.data[1].resource_function === "stub" ? true : false
      );
      setSandboxResourceURL(
        api_rsp.data[1].resource_function === "stub"
          ? ""
          : api_rsp.data[1].resource_location
      );
      // production
      setProductionAuthURL(api_rsp.data[0].auth_location);
      setProductionResourceURL(api_rsp.data[0].resource_location);
    }
  };

  return (
    <div>
      <AdminTopBar />
      <div className="section__master">
        <div className="grid grid-cols-12 gap-6">
          
          <div className="col-span-12 lg:col-span-12 xxl:col-span-12">
            <div className="Section__body">
              <div className="intro-y box">
                <div className="flex items-center  pt-0 border-b border-gray-200">
                  <h2 className="font-medium text-base mr-auto">
                    <i className="">
                      <FontAwesomeIcon icon={faLock} />
                    </i>{" "}
                    &nbsp;&nbsp;Authorisation Integration
                  </h2>
                </div>
                <p>
                  Tell.connect integrates with your application for
                  Authorisation (approving user consents) and access to
                  Resources (account information & payments). See The User Guide
                  for more information. Please provide the location for these
                  services on your application. You can edit these at any time.
                </p>

                <div className="p-lg-5">
                  <div className="intro-y box lg:mt-5">
                    <div className="intro-y box lg:mt-5">
                      <div className={"card card-form " + themeState.theme}>
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Sandbox Authorisation
                              </strong>
                            </p>
                            <p className="upl_txt">
                            The Auth Location is a page on your application
                              where you can present the user with confirmation
                              of the consent being requested, and enable them to
                              authenticate themseves and confirm if they wish to
                              approve or reject the request. In sandbox you may choose to use the tell simulator.
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body align-items-center">
                            <div className="flex mt-3">
                              <label htmlFor="togBtnA" for="subscribe">
                                Use Authorisation Simulator :
                              </label>
                            </div>
                            <label className="switch mt-1">
                              <input
                                type="checkbox"
                                checked={isSandboxAuthSimulator}
                                id="togBtnA"
                                onChange={() =>
                                  setIsSandboxAuthSimulator(
                                    !isSandboxAuthSimulator
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>

                            <div className="form-group mt-3">
                              <label  htmlFor="togBtnB" for="exampleInputPassword1">
                                Simulator Location (URL / deep link) :
                              </label>
                              <input
                                disabled={isSandboxAuthSimulator}
                                className="form-control"
                                type="text"
                                value={sandboxAuthURL}
                                id="togBtnB"
                                placeholder="https://example.com .."
                                onChange={handleSandboxAuthURL}
                              />
                            </div>
                            <div className="text-left mt-3">
                              <button
                                className="cca-btn"
                                id="login_button"
                                type="button"
                                onClick={saveSandboxAuthConf}
                              >
                                <div>
                                  Save<span></span>
                                  <i className="sbmt_but_icon">
                                    <FontAwesomeIcon icon={faSave} />
                                  </i>
                                </div>
                                <span></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card card-form mt-3 " + themeState.theme}
                      >
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Production Authorisation
                              </strong>
                            </p>
                            <p className="upl_txt">
                              The Auth Location is a page on your application
                              where you can present the user with confirmation
                              of the consent being requested, and enable them to
                              authenticate themseves and confirm if they wish to
                              approve or reject the request.
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body">
                            <form>
                              <div className="form-group mt-5">
                                <label  htmlFor="togBtnC" for="exampleInputPassword1">
                                  Production Location (URL / Deep Link) :
                                </label>

                                <input
                                  className="form-control"
                                  type="text"
                                  value={productionAuthURL}
                                  name="productionAuthUrl"
                                  id="togBtnC"
                                  placeholder="https://example.com .."
                                  onChange={handleProductionAuthURL}
                                />
                              </div>
                              <div className="text-left mt-3">
                                <button
                                  className="cca-btn"
                                  id="login_button"
                                  type="button"
                                  onClick={saveProductionAuthConf}
                                >
                                  <div>
                                    Save<span></span>
                                    <i className="sbmt_but_icon">
                                      <FontAwesomeIcon icon={faSave} />
                                    </i>
                                  </div>
                                  <span></span>
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="Section__body">
              <div className="intro-y box">
                <div className="flex items-center  pt-0 border-b border-gray-200">
                  <h2 className="font-medium text-base mr-auto">
                    <i className="">
                      <FontAwesomeIcon icon={faDatabase} />
                    </i>{" "}
                    &nbsp;&nbsp;Resource Integration
                  </h2>
                </div>
                <p>
                  Tell.connect integrates with your application for
                  Authorisation (approving user consents) and access to
                  Resources (account information & payments). See The User Guide
                  for more information. Please provide the location for these
                  services on your application. You can edit these at any time.
                </p>

                <div className="p-lg-5">
                  <div className="intro-y box lg:mt-5">
                    <div className="intro-y box lg:mt-5">
                      <div className={"card card-form " + themeState.theme}>
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">Sandbox Resource</strong>
                            </p>
                            <p className="upl_txt">
                            
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body align-items-center">
                            <div className="flex mt-3">
                              <label htmlFor="togBtnD" for="subscribe">
                                Use Sandbox Stub Data Environment :
                              </label>
                            </div>
                            <label className="switch mt-1">
                              <input
                                type="checkbox"
                                id="togBtnD"
                                checked={isSandboxResourceSimulator}
                                onChange={() =>
                                  setIsSandboxResourceSimulator(
                                    !isSandboxResourceSimulator
                                  )
                                }
                              />
                              <div className="slider round"></div>
                            </label>

                            <div className="form-group mt-3">
                              <label htmlFor="togBtnE" for="exampleInputPassword1">
                                Sandbox Resource Location (URL) :
                              </label>
                              <input
                                type="url"
                                className="form-control"
                                id="togBtnE"
                                onChange={handleSandboxResourceURL}
                                value={sandboxResourceURL}
                                disabled={isSandboxResourceSimulator}
                                placeholder="https://example.com .."
                              />
                            </div>
                            <div className="text-left mt-3">
                              <button
                                className="cca-btn"
                                id="login_button"
                                type="button"
                                onClick={saveSandboxAuthConf}
                              >
                                <div>
                                  Save<span></span>
                                  <i className="sbmt_but_icon">
                                    <FontAwesomeIcon icon={faSave} />
                                  </i>
                                </div>
                                <span></span>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className={"card card-form mt-3 " + themeState.theme}
                      >
                        <div className="row no-gutters">
                          <div className="col-lg-4 card-body">
                            <p>
                              <strong className="upl_hdr">
                                Production Resource
                              </strong>
                            </p>
                            <p className="upl_txt">
                            
                            </p>
                          </div>
                          <div className="col-lg-8 card-form__body card-body">
                            <form>
                              <div className="form-group mt-5">
                                <label  htmlFor="togBtnF" for="exampleInputPassword1">
                                  Production Resource Location (URL) :
                                </label>
                                <input
                                  type="url"
                                  className="form-control"
                                  id="togBtnF"
                                  onChange={handleProductionResourceURL}
                                  value={productionResourceURL}
                                  placeholder="https://example.com .."
                                />
                              </div>
                              <div className="text-left mt-3">
                                <button
                                  className="cca-btn"
                                  id="login_button"
                                  type="button"
                                  onClick={saveProductionAuthConf}
                                >
                                  <div>
                                    Save<span></span>
                                    <i className="sbmt_but_icon">
                                      <FontAwesomeIcon icon={faSave} />
                                    </i>
                                  </div>
                                  <span></span>
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integrate;
